<template>
    <div class="player-stats-box">

        <!-- <div id="playerStatsLeagueId">
            league list
        </div>
        <div id="playerStatsSeasonId">
            season date
        </div> -->

        <div class="result-list">
            <div class="result-item">
                <div class="result-bg">
                    <div class="result-padding">
                        <div class="result-title">
                            {{ $t('APPEARANCES') }}
                        </div>
                        <div class="result-content">
                            8
                        </div>
                    </div>
                </div>
            </div>
            <div class="result-item">
                <div class="result-bg">
                    <div class="result-padding">
                        <div class="result-title">
                            {{ $t('GOALS') }}
                        </div>
                        <div class="result-content">
                            8
                        </div>
                    </div>
                </div>
            </div>
            <div class="result-item">
                <div class="result-bg">
                    <div class="result-padding">
                        <div class="result-title">
                            {{ $t('WINS') }}
                        </div>
                        <div class="result-content">
                            8
                        </div>
                    </div>
                </div>
            </div>
            <div class="result-item">
                <div class="result-bg">
                    <div class="result-padding">
                        <div class="result-title">
                            {{ $t('LOSSES') }}
                        </div>
                        <div class="result-content">
                            8
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="stats-list">
            <div class="stats-content">
                <div class="stats-content-title">
                    {{ $t('Attack') }}
                </div>
                <div class="state-content-list">
                    <div class="state-content-item" v-for="i in statsInfo.attack">
                        <div>{{$t(i.name)}}</div>
                        <div class="bold">1</div>
                    </div>
                </div>
            </div>
            <div class="state-content-center">
                <div class="stats-content">
                    <div class="stats-content-title">
                        {{ $t('TEAM_PLAY') }}
                    </div>
                    <div class="state-content-list">
                        <div class="state-content-item" v-for="i in statsInfo.teamPlay">
                            <div>{{ $t(i.name) }}</div>
                            <div class="bold">1</div>
                        </div>
                    </div>
                </div>
    
                <div class="stats-content mt24">
                    <div class="stats-content-title">
                        {{ $t('DISCIPLINE') }}
                    </div>
                    <div class="state-content-list">
                        <div class="state-content-item" v-for="i in statsInfo.discipline">
                            <div>{{ $t(i.name) }}</div>
                            <div class="bold">1</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="stats-content defence-content">
                <div class="stats-content-title">
                    {{ $t('DEFENCE') }}
                </div>
                <div class="state-content-list">
                    <div class="state-content-item" v-for="i in statsInfo.defence">
                        <div>{{ $t(i.name) }}</div>
                        <div class="bold">1</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
    import MobileSelect from "mobile-select"; //"@/lib/mobile-select"
    let mobileSelectSeason; // defined mobile select dropdown component for season
    let mobileSelecLeague; // defined mobile select dropdown component for season
    export default {
        name: 'footballPlayerStats',
        data() {
            return {
                statsInfo: {
                    attack: [
                        {
                            name: 'GOALS',
                        },
                        {
                            name: 'GOALS_WITH_LEFT_FOOT',
                        },
                        {
                            name: 'GOALS_WITH_RIGHT_FOOT',
                        },
                        {
                            name: 'SHOTS',
                        },
                        {
                            name: 'SHOTS_ON_TARGET',
                        },
                        {
                            name: 'PENALTIES_SCORED',
                        },
                        {
                            name: 'BIG_CHANCES_CREATED',
                        },
                        {
                            name: 'HIS_WOODWORK',
                        }
                    ],
                    teamPlay: [
                        {
                            name: 'BIG_CHANCES_CREATED',
                        },
                        {
                            name: 'MOST_PASSES',
                        },
                        {
                            name: 'CROSSES',
                        }
                    ],
                    discipline: [
                        {
                            name: 'OFFSIDES'
                        },
                        {
                            name: 'YELLOW_CARDS'
                        },
                        {
                            name: 'FOULS'
                        }
                    ],
                    defence: [
                    {
                            name: 'CLEAN_SHEETS'
                        },
                        {
                            name: 'TACKLES'
                        },
                        {
                            name: 'INTERCEPTION'
                        },
                        {
                            name: 'RECOVERIES'
                        },
                        {
                            name: 'DUELS_WON'
                        },
                        {
                            name: 'DUELS_LOST'
                        },
                        {
                            name: 'SUCCESSFUL_50_50S'
                        },
                        {
                            name: 'AERIAL_BATTLES_WON'
                        },
                        {
                            name: 'AERIAL_BATTLES_LOST'
                        },
                        {
                            name: 'BLOCKED_SHOTS'
                        },
                        {
                            name: 'CLEARANCES'
                        }
                    ]
                }
            }
        },
        mounted() {
            // this.selectLeague()
            // this.selectSeasons()
        },
        methods: {
            selectLeague() {
                this.$nextTick(() => {
                    let mobileSelectData = []
                    let title = this.$i18n.t("SELECT_SEASON");
                    let ensureBtnText = this.$i18n.t("DONE");
                    let cancelBtnText = this.$i18n.t("CANCEL");

                    let ensureBtnColor = "var(--color-text-primary-default)";
                    let titleBgColor = "#F0F0F0";

                    // if (type === "standings") {
                        mobileSelectData.push({
                        id: "null",
                        value: this.$i18n.t("SEASON"),
                        });
                    // }
                    
                    if (mobileSelecLeague) {
                        mobileSelecLeague.destroy();
                    }
                    let triggerId = '#playerStatsLeagueId'

                    mobileSelecLeague = new MobileSelect({
                        trigger: triggerId,
                        triggerDisplayData: false,
                        triggerDisplayValue: false,
                        title: title,
                        ensureBtnText: ensureBtnText,
                        cancelBtnText: cancelBtnText,
                        ensureBtnColor: ensureBtnColor,
                        titleBgColor: titleBgColor,

                        wheels: [
                        {
                            data: mobileSelectData,
                        },
                        ],

                        callback: function (indexArr, data) {
                        }
                    })

                    mobileSelecLeague.locatePosition(0, 0);
                })
            },
            selectSeasons() {
                this.$nextTick(() => {
                    let mobileSelectData = []
                    let title = this.$i18n.t("SELECT_SEASON");
                    let ensureBtnText = this.$i18n.t("DONE");
                    let cancelBtnText = this.$i18n.t("CANCEL");

                    let ensureBtnColor = "var(--color-text-primary-default)";
                    let titleBgColor = "#F0F0F0";

                    // if (type === "standings") {
                        mobileSelectData.push({
                            id: "null",
                            value: this.$i18n.t("SEASON"),
                        });
                        mobileSelectData.push({
                            id: "1",
                            value: '2024/2025'
                        });
                    // }
                    
                    if (mobileSelectSeason) {
                        mobileSelectSeason.destroy();
                    }
                    let triggerId = '#playerStatsSeasonId'

                    mobileSelectSeason = new MobileSelect({
                        trigger: triggerId,
                        triggerDisplayData: false,
                        triggerDisplayValue: false,
                        title: title,
                        ensureBtnText: ensureBtnText,
                        cancelBtnText: cancelBtnText,
                        ensureBtnColor: ensureBtnColor,
                        titleBgColor: titleBgColor,

                        wheels: [
                        {
                            data: mobileSelectData,
                        },
                        ],

                        callback: function (indexArr, data) {
                        }
                    })

                    mobileSelectSeason.locatePosition(0, 0);
                })
            }
        }
    }
</script>

<style scoped>
.result-list {
    display: flex;
    align-items: center;
    gap: 16px;
}
.result-item {
    width: 25%;
    height: 98px;
    background-color: var(--white-1000);
    border-radius: 16px;
    box-sizing: border-box;
}
.result-bg {
    width: 100%;
    height: 100%;
    background-image: url('../../../../../static/images/icons/aspn_icon/player/player_stats_bg.png');
    background-size: 100%;
}
.result-title {
    font-size: 14px;
    margin-bottom: 8px;
	letter-spacing: 0.64px;
}
.result-padding {
    padding: 16px;
    box-sizing: border-box;
}
.result-content {
    font-size: 32px;
	line-height: 120%;
    font-family: var(--weight-700);
}
.stats-list {
    margin: 22px 0;
    display: flex;
    gap: 24px;
}
.stats-content {
    width: 33.33%;
    padding: 16px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: var(--white-1000);
}
.state-content-center {
    width: 33.33%;
}
.state-content-center .stats-content {
    width: 100%;
}
.stats-content-title {
    font-size: 20px;
    font-family: var(--weight-600);
    padding: 10px 0;
}
.state-content-list {

}
.state-content-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    font-size: 14px;
	letter-spacing: 0.64px;
}
.mt24 {
    margin-top: 24px;
}
@media(max-width: 768px) {  /* for test */
.result-list {
    width: calc(100% - 16px);
    display: grid;
    grid-template-columns: repeat(2, 50%);
    gap: 8px;
    margin-top: 0;
}
.result-item {
    width: 100%;
    background-color: var(--gray-50);
    border: 1px  solid var(--gray-300);
}
.player-stats-box {
    padding: 16px;
    box-sizing: border-box;
    background-color: var(--white-1000);
    margin: 16px 8px;
    width: calc(100% - 16px);
    border-radius: 8px;
}
.stats-list {
    display: block;
    margin-bottom: 0;
}
.stats-content {
    width: 100%;
    padding: 0;
    border-radius: 0;
    border-bottom: 1px solid var(--gray-300);
    padding-bottom: 8px;
    margin-bottom: 8px;
}
.state-content-center {
    width: 100%;
}
.defence-content {
    border-bottom: 0;
    padding-bottom: 0;
    margin-bottom: 0;
}
}
</style>